import _ from 'lodash';
import platformUtils from '../privates/platformUtils';

/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK THIS IS BEING USED IN THE SDK:
 * @typedef $w.Link
 * @summary An object that describes the link set on linkable items.
 *  In the Wix Platform, a link can be a link to a site page, a document, an email, or an external web page.
 * @property {$w.LinkType} type The type of link
 * @property {external:String} [pageId] The ID of the page to link to if the `LinkType` is `PAGE`
 * @property {external:String} [url] The URL to link to if the `LinkType` is `EXTERNAL`
 * @property {external:String} [target] The target of the link, either `_blank` or `_self`
 * @property {external:String} [emailAddress] The email address to open if the `LinkType` is `EMAIL`
 * @property {external:String} [emailSubject] The subject of the email if the `LinkType` is `EMAIL`
 * @property {external:String} [documentUrl] The URL of the document to link to if the `LinkType` is `DOCUMENT`. The document must be hosted on Wix.
 */

const Link = (function () {
    function _formatLinkItem(linkItem) {
        const linkUtils = platformUtils.getLinkUtils();
        const formattedLinkItem = _.clone(linkItem);
        if (formattedLinkItem.anchorDataId) {
            formattedLinkItem.anchorDataId = linkUtils.getAnchorDataId(formattedLinkItem);
        }
        if (formattedLinkItem.pageId) {
            formattedLinkItem.pageId = linkUtils.getPageId(formattedLinkItem);
        }
        return formattedLinkItem;
    }

    function _extractAnchorName(linkItem) {
        const formattedLinkItem = _.clone(linkItem);
        if (_.isPlainObject(linkItem.anchorDataId)) {
            const RMI = platformUtils.getRMI('Link');
            const anchorCompId = linkItem.anchorDataId.compId;
            const anchorComp = RMI.getComp(anchorCompId);
            formattedLinkItem.anchorDataId = anchorComp ? anchorComp.id : linkItem.anchorDataId.id;
        }
        return formattedLinkItem;
    }

    function LinkFromString(value, target) {
        const siteStructure = platformUtils.getRMI().getSiteStructure();
        this._linkObject = platformUtils.getLinkUtils().convertUrlToLinkObject(siteStructure.prefixes, value, target, siteStructure.pages);
        this._link = value;
    }

    function LinkFromItem(linkItem) {
        if (linkItem.pageId && _.isPlainObject(linkItem.pageId)) {
            linkItem.pageId = `#${linkItem.pageId.id}`;
        }
        const linkUtils = platformUtils.getLinkUtils();
        const updatedLinkItem = _extractAnchorName(linkItem);
        const siteStructure = platformUtils.getRMI().getSiteStructure();
        this._link = linkUtils.convertLinkObjectToUrl(siteStructure.prefixes, updatedLinkItem, siteStructure.pages);
        this._linkObject = _formatLinkItem(updatedLinkItem);
    }

    function Link(value, target) {
        switch (typeof value) {
            case 'string':
                LinkFromString.call(this, value, target);
                break;
            case 'object':
                LinkFromItem.call(this, value, target);
                break;
        }
    }

    Link.prototype.getValue = function getValue() {
        return this._link;
    };

    Link.prototype.getData = function getData() {
        return this._linkObject;
    };

    return Link;
})();

export default Link;
